import { render, staticRenderFns } from "./DhrDetail.vue?vue&type=template&id=5c07c69e&scoped=true&"
import script from "./DhrDetail.vue?vue&type=script&lang=js&"
export * from "./DhrDetail.vue?vue&type=script&lang=js&"
import style0 from "./DhrDetail.vue?vue&type=style&index=0&id=5c07c69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c07c69e",
  null
  
)

export default component.exports